import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pia-transcript-viewer',
  templateUrl: './pia-transcript-viewer.component.html',
  styleUrls: ['./pia-transcript-viewer.component.scss'],
})
export class PiaTranscriptViewerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
